import React,{useMemo} from 'react';
import SectionTitle from '../../components/Common/SectionTitle';
import Footer from '../../components/Layout/Footer';
import SearchModal from '../../components/Layout/Header/SearchModal';
import SiteBreadcrumb from '../../components/Common/Breadcumb';
import ServiceDetailsContent from './ServiceDetailsContent';

// Breadcrumbs Image
import breadcrumbsImg from '../../assets/img/breadcrumbs/2.jpg';
import serviceImg from '../../assets/img/service/2.png';
import DetailsHeader from '../../components/Layout/Header/DetailsHeader';

const ProductDevelopment = () => {
    const content = useMemo(() => {
        return <SectionTitle
            sectionClass="sec-title4"
            descClass="desc desc-big"
            description="User-centered product development: ideation, prototyping, testing, and launch support to bring products to market."
        />
    }, [])
    return (
        <React.Fragment>
            <DetailsHeader
                parentMenu='service'
                secondParentMenu='services'
                activeMenu='/product-development'
            />
            <SiteBreadcrumb
                breadcrumbsImg={breadcrumbsImg}
                pageTitle='Product Development & Innovation'
                pageCategory='Services'
                pageName='Product Development'
                parentPath="/service"
            />
            <ServiceDetailsContent title="Product Development & Innovation" subtitle="Product Development" children={content} serviceImg={serviceImg}/>
            <Footer footerClass="rs-footer" />
            <SearchModal />
        </React.Fragment>
    );
}

export default ProductDevelopment;
